import { render } from "./NavBar.vue?vue&type=template&id=0a5d8b4c"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=0a5d8b4c&lang=css"

import exportComponent from "/Users/macbookpro/Desktop/thecustomer/st-daara/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__